<template>
  <div class="footer" id="footer">
    <b-container class="footerCorpo">
      <b-row>
        <b-col sm="5" class="support">
          <div class="titulo">
            <p>{{ $t('tituloApoio') }}</p>
            <b-img :src="svgTitulo" class="svgTituloApoio"></b-img>
          </div>
          <b-row>
            <b-col cols="12" sm="12">
              <b-img class="apoiador img-apoiador" v-bind:src="zetta"></b-img>
              <b-img class="img-apoiador" v-bind:src="ufla"></b-img>
            </b-col>
          </b-row>
        </b-col>

        <b-col sm="7" class="colunaLocalizacao">
          <b-row>
            <b-col cols="12" sm="12">
              <p class="titulo">{{ $t('tituloLocalizacao') }}</p>
              <b-img :src="svgTitulo" class="svgTituloLocalizacao"></b-img>
            </b-col>
            <b-col cols="12" sm="12">
              <!-- <p class="localizacao">{{localizacao}}</p> -->
              <p class="localizacao">
                <br />
                {{ $t('textoLocalizacao') }}
              </p>
              <b-img class="img-localizacao" v-bind:src="localizacao"></b-img>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid class="footerLaranja">
      <b-button href="https://compjunior.com.br/" variant="link">
        <b-img :src="footerComp" class="footerComp"></b-img>
      </b-button>
    </b-container>
  </div>
</template>

<style scoped>
.footer {
  background-image: url("~@/assets/Footer/fundoFooter.png");
  background-repeat: no-repeat;
  background-size: cover;
  color: #ffffff;
}

.footerCorpo {
  padding-top: 25px;
  margin-bottom: 50px;
}

.titulo {
  margin-top: 75px;
  margin-bottom: 15px;
  font-size: 1.8em;
  text-align: center;
}

.support {
  display: grid;
}

.apoiador {
  margin-bottom: 50px;
}

.localizacao {
  text-align: center !important;
  font-weight: lighter;
  font-size: 18px;
}

.svgTituloApoio {
  height: 3px;
  width: 85px;
  margin-top: -85px;
}

.svgTituloLocalizacao {
  height: 3px;
  width: 190px;
  margin-top: -55px;
}

.img-apoiador {
  width: 60%;
  height: auto;
}

.img-localizacao {
  width: 44%;
  height: auto;
}

.colunaLocalizacao {
  padding-left: 75px;
}

.footerLaranja {
  background-image: url("~@/assets/Footer/footerLaranja.svg");
  background-position-x: center;
  background-size: cover;
  text-align: right;
}

.footerComp {
  height: 35px;
  padding-right: 20px;
}

@media only screen and (max-width: 768px) {
  .colunaLocalizacao {
    padding-left: 15px;
  }
  .footerLaranja {
    background-size: auto 100%;
    background-position-x: center;
    text-align: right;
  }
  .footerComp {
    padding-top: 2px;
  }
}
@media only screen and (max-width: 575px) {
  .img-apoiador {
    width: 50.1%;
    height: auto;
  }

  .img-localizacao {
    width: 40%;
    height: auto;
  }
}
</style>

<script>
export default {
  name: "Organizacao",
  data() {
    return {
      ufla: require("../assets/Footer/ufla.png"),
      zetta: require("../assets/Footer/zetta.png"),
      svgTitulo: require("../assets/Footer/svgTitulo.png"),
      footerLaranja: require("../assets/Footer/footerLaranja.svg"),
      footerComp: require("../assets/Footer/footerComp.png"),
      localizacao: require("../assets/Footer/localizacao.png")
      // localizacao:
      //   "Rua Lorem Ipsum 206 - Departamento de Computação Universidade Federal de Lavras",
    };
  }
};
</script>